import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDeliveryFees } from "../../constants";
import { DeleteDeliveryLocationBody } from "./deleteDeliveryLocation.types";

export const requestCreateDeliveryLocation = async (
  body: DeleteDeliveryLocationBody
): Promise<void> => {
  const getUrl = () => {
    if (body.areaName) {
      return buildUrl(ApiRoutesDeliveryFees.DeliveryLocationArea);
    }
    if (body.cityName) {
      return buildUrl(ApiRoutesDeliveryFees.DeliveryLocationCity);
    }

    return buildUrl(ApiRoutesDeliveryFees.DeliveryLocationCountry);
  };

  return await instance.delete(getUrl(), { data: body });
};
